<template>
  <div class="content">
    <!-- <img src="../assets/about_us_banner.png" style="width:100%;height:100%;margin-bottom:-8px;"> -->
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Company</el-breadcrumb-item>
      <el-breadcrumb-item>About us</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="message">
      <h2>About us</h2>
      <p>"Let there be light," Genesis 1:3-5. Light and molecules are the building blocks of life, the keys to unlock its secrets, and the tools to understand its mysteries.</p>
      <p>"I could exceed well see the borders or circles of those little rooms, or cells, as I may call them." In his book Micrographia, 1665. Robert Hooke's described mankind’s first observations of cells under a microscope, which is a major milestone in the development of modern biology. The word “cell” is derived from the Greek word “κελλιο", or “Kellio”.</p>
      <p>Kelliop is a world class precision medicine company founded by healthcare industry veterans and Berkeley scientists, using lab-on-chip and state-of-the-art photonics and space-age thermal management technology to enable just-in-time clinical decisions at point-on-care. Our RapidSeq126® device is a rapid, versatile, simple-to-use and robust sample-to-answer molecular diagnostics platform for use in triage of patients, genotyping, pathogen detection and other clinical indications such as infectious disease detection, and oncology.</p>
      <p>Our team have developed innovative tests for the detection of genetic variants in prenates and neonates, confirmation of gastrointestinal infection prior to drug administration, a point-of-care system for respiratory pathogen detection of COVID-19 and influenza, RSV, adenovirus. Our focus has increasingly moved to emergency medicine, where the delivery of genetic information more quickly than competitor’s systems is a strength of our technology. Kelliop is deploying multiple commercial genetic tests into emergency care settings.</p>
      <p>Kelliop is based in San Francisco Bay Area and Singapore, serving clinical markets in U.S., Europe, ASEAN, and Latin America now.</p>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'Abouts',
        data () {
            return {

            }
        },
        mounted() {
        },
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
.message {
  padding: 50px 119px 100px 119px;
}
.message h2 {
  margin-bottom: 57px;
  color: #000000;
  font-size: 30px;
  font-weight: bold;
}
.message p {
  margin-bottom: 45px;
  color: #343434;
  font-size: 16px;
  line-height: 30px;
}

::v-deep .el-breadcrumb__inner.is-link {
  font-weight: 400;
}
</style>